import {DependencyChunk} from "../chunks/types/DependencyChunk";
import {DependencyDef} from "./types/DependencyDef";
import {getStringFromStringChunk} from "./utils/getStringFromStringChunk";

export function dependencyChunkToDependencyDef(
  dependencyChunk: DependencyChunk
): DependencyDef {
  const {
    captures: {
      1: stringChunk
    }
  } = dependencyChunk;
  return {
    name: getStringFromStringChunk(stringChunk)
  };
}
